import React from "react";

// Segmented / pill options. Disabled options stay visible with a hint.
export const Seg = ({ label, options, value, onChange, isEnabled = () => true, testid, hint }) => (
  <div className="flex flex-col gap-1.5" data-testid={testid}>
    {label && <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-zinc-500">{label}</span>}
    <div className="flex flex-wrap gap-1 bg-[#0D0D0F] border border-zinc-800 rounded-lg p-0.5">
      {options.map((o) => {
        const v = typeof o === "object" ? o.value : o;
        const l = typeof o === "object" ? o.label : o;
        const ok = isEnabled(v);
        return (
          <button key={v} type="button" disabled={!ok} onClick={() => onChange(v)}
            title={ok ? "" : hint || "Not supported by this model"}
            data-testid={`${testid}-${String(v).replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
            className={`px-2.5 h-7 rounded-md text-xs font-medium transition-colors ${
              value === v ? "bg-zinc-100 text-black" : ok ? "text-zinc-300 hover:bg-zinc-800 hover:text-white" : "text-zinc-700 cursor-not-allowed line-through decoration-zinc-700"
            }`}>{l}</button>
        );
      })}
    </div>
  </div>
);

export const Field = ({ label, children, hint }) => (
  <div className="flex flex-col gap-1.5">
    <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-zinc-500">{label}</span>
    {children}
    {hint && <span className="text-[11px] text-zinc-600">{hint}</span>}
  </div>
);
